import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconStar from 'components/icons/iconStar';
const ReviewStarIcon = t0 => {
  const $ = _c(11);
  const {
    height: t1,
    width: t2,
    offsetValue: t3,
    starNumber,
    setHoverValue: t4,
    hoverValue,
    rating
  } = t0;
  const height = t1 === undefined ? 16 : t1;
  const width = t2 === undefined ? 16 : t2;
  const offsetValue = t3 === undefined ? 0 : t3;
  const setHoverValue = t4 === undefined ? _temp : t4;
  const isHovered = hoverValue >= starNumber || rating >= starNumber;
  let t5;
  if ($[0] !== setHoverValue || $[1] !== starNumber) {
    t5 = () => {
      setHoverValue(starNumber);
    };
    $[0] = setHoverValue;
    $[1] = starNumber;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const onPointerEnter = t5;
  let t6;
  if ($[3] !== setHoverValue) {
    t6 = () => {
      setHoverValue(0);
    };
    $[3] = setHoverValue;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const onPointerLeave = t6;
  const offset = isHovered ? 1 : offsetValue;
  let t7;
  if ($[5] !== height || $[6] !== offset || $[7] !== onPointerEnter || $[8] !== onPointerLeave || $[9] !== width) {
    t7 = <IconStar offsetValue={offset} width={width} height={height} onPointerEnter={onPointerEnter} onPointerLeave={onPointerLeave} />;
    $[5] = height;
    $[6] = offset;
    $[7] = onPointerEnter;
    $[8] = onPointerLeave;
    $[9] = width;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
ReviewStarIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  offsetValue: PropTypes.number,
  starNumber: PropTypes.number,
  setHoverValue: PropTypes.func,
  hoverValue: PropTypes.number,
  rating: PropTypes.number
};
export default ReviewStarIcon;
function _temp() {}